'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Navi;
(function (Navi) {
    var MyNavi = /** @class */ (function () {
        function MyNavi() {
            var self = this;
            self.createNaviMargin();
            $('.trigSearchSwitch').on('click', function () {
                var open = Number($('.paramSearchSwitch').attr('data-show'));
                if (open == 0) {
                    $('.paramSearchSwitch').attr('data-show', 1);
                    $('#bulletSearchInput').show(0, function () {
                        $('.trigSearchSwitch').children('i').removeClass('fa-search');
                        $('.trigSearchSwitch').children('i').addClass('fa-close');
                        $('#bulletSearchInput').animate({
                            width: 150,
                        }, 'fast', 'linear', function () {
                            self.createNaviMargin();
                        });
                        $('#bulletSeachBtn').show();
                    });
                }
                else {
                    $('.paramSearchSwitch').attr('data-show', 0);
                    $('#bulletSearchInput').animate({
                        width: 0,
                    }, 'fast', 'linear', function () {
                        $('.trigSearchSwitch').children('i').removeClass('fa-close');
                        $('.trigSearchSwitch').children('i').addClass('fa-search');
                        $('#bulletSearchInput').hide();
                        $('#bulletSeachBtn').hide();
                        self.createNaviMargin();
                    });
                }
            });
        }
        MyNavi.prototype.createNaviMargin = function () {
            var naviWidth = $('.paramSearchWindow').outerWidth();
            var naviRightMargin = parseInt($('.paramSearchWindow').css('right'));
            var createMargin = naviWidth + naviRightMargin + 10;
            $('.bulletSearchMargin').css('padding-right', createMargin);
        };
        return MyNavi;
    }());
    Navi.MyNavi = MyNavi;
})(Navi || (Navi = {}));
exports.default = Navi;
